export {cookieSecuritySettings} from './cookieSecuritySettings'
import Cookies from 'js-cookie'

export const getCookie = Cookies.get
export const removeCookie = Cookies.remove
export const setCookie = Cookies.set
export const getAllCookies = Cookies.get
